module.exports = __webpack_public_path__ + "assets/img/0d38718291de5d378cbe9c6abd4b0c97.png";